import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { BbTableService } from '../services/bb-table.service';
import { BbTableContainerComponent } from '../components/shared/bb-table/bb-table-container.component';
import { BbTableCellComponent } from '../components/shared/bb-table/bb-table-cell.component';
import { BbTableHeaderCellComponent } from '../components/shared/bb-table/bb-table-header-cell.component';
import { BbTableRowComponent } from '../components/shared/bb-table/bb-table-row.component';
import { BbTableHeaderComponent } from '../components/shared/bb-table/bb-table-header.component';
import { BbTablePagerComponent } from '../components/shared/bb-table/bb-table-pager.component';
import { BbTableLocalFilterComponent } from '../components/shared/bb-table/bb-table-local-filter.component';

import { PipesModule } from './pipes.module';
import { InputsModule } from './inputs.module';
import { MaterialModule } from './material.module';



@NgModule({
	imports: [
		CommonModule,
		InputsModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		PipesModule,
		MaterialModule
	],
	declarations: [
		BbTableContainerComponent,
		BbTableCellComponent,
		BbTableHeaderCellComponent,
		BbTablePagerComponent,
		BbTableRowComponent,
		BbTableHeaderComponent,
		BbTableLocalFilterComponent
	],
	exports: [
		BbTableContainerComponent,
		BbTableCellComponent,
		BbTableHeaderCellComponent,
		BbTablePagerComponent,
		BbTableRowComponent,
		BbTableHeaderComponent,
		BbTableLocalFilterComponent
	],
	providers: [
		BbTableService
	]
})
export class BbTableModule {

}
